<template>
    <div  >


        <div class="lc_c_about_locks TQ_center TQ_inline TQ_verticalAlignMiddle">
            <div v-for="(item,index) in locks_ao" class="lc_line" :ref="m_getLineName_fs(index)"></div>

            <img @click="m_rotateLocks_f" :src="ass_img_lock_w" class="lc_lock TQ_clickable TQ_width_40px TQ_bg_black TQ_padding_8px TQ_borderRadius"/>

            <img v-for="(lock_o, index) in locks_ao"
                 :src="lock_o.img"
                 :class="{'lc_selectedLock' : selectedIndex_n === lock_o.id}"
                 @click="m_clickLock_f(lock_o)"
                 :ref="m_getLockName_fs(index)"
                 class="lc_lock1 TQ_width_36px TQ_bg_gray4 TQ_padding_8px TQ_borderRadius TQ_clickable " />
        </div>


        <div class="TQ_inline TQ_verticalAlignMiddle">
            <div class="TQ_text_24px">
                {{locks_ao[selectedIndex_n].title_blc_s[p_systemLangCode_e]}}
            </div>

            <tq-image :pb_src_r="locks_ao[selectedIndex_n].gif" class="TQ_maxWidth_250px TQ_width_100p TQ_verticalAlignMiddle TQ_box_shadow TQ_borderRadius "/>
        </div>

    </div>
</template>

<script>
    import {
        ass_gif_lock_includeText,
        ass_gif_lock_options, ass_gif_lock_quiz, ass_gif_lock_text,
        ass_img_about_tqAppGif,
        ass_img_lock_w,
        ass_img_lockImage_b,
        ass_img_lockIncludeText_b,
        ass_img_lockOptions_b,
        ass_img_lockQuiz_b,
        ass_img_lockText_b,
        ass_img_lockVideo_b,
        ass_img_lockWords,
        ass_img_QrCode_b
    } from "../../../assets/scripts/Ass_Files";
    import {date_setInterval} from "../../../scripts/S_Date";
    import {validator_enum_fb} from "../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqImage from "../../../components/basic/TqImage";

    export default {
        name: "c_About_Locks",
        components: {TqImage},
        props:{
            p_systemLangCode_e:{
                type: String,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
        },
        data(){
            return {

                selectedIndex_n : 3,

                ass_img_lockWords : ass_img_lockWords,
                ass_img_lock_w : ass_img_lock_w,




                locks_ao : [
                    {refLine: null, refImg: null, img: ass_img_lockText_b,           id : 0 ,    deg : 30,  gif: ass_gif_lock_text,         title_blc_s: ass_strings.twoWords_lockTitle},
                    {refLine: null, refImg: null, img: ass_img_lockIncludeText_b,    id : 1 ,    deg : 50,  gif: ass_gif_lock_includeText,  title_blc_s: ass_strings.threeWords_includesWordsLock},
                    {refLine: null, refImg: null, img: ass_img_lockOptions_b,        id : 2 ,    deg : 70,  gif: ass_gif_lock_options,      title_blc_s: ass_strings.twoWords_optionLock},
                    {refLine: null, refImg: null, img: ass_img_lockQuiz_b,           id : 3 ,    deg : 90,  gif: ass_gif_lock_quiz,         title_blc_s: ass_strings.twoWords_quizLock},
                    {refLine: null, refImg: null, img: ass_img_QrCode_b,             id : 4 ,    deg : 110, gif: ass_img_about_tqAppGif,    title_blc_s: ass_strings.twoWords_qrLock},
                    {refLine: null, refImg: null, img: ass_img_lockImage_b,          id : 5 ,    deg : 130, gif: ass_img_about_tqAppGif,    title_blc_s: ass_strings.twoWords_imageLock},
                    {refLine: null, refImg: null, img: ass_img_lockVideo_b,          id : 6 ,    deg : 150, gif: ass_img_about_tqAppGif,    title_blc_s: ass_strings.twoWords_videoLock},
                ]
            }
        },
        methods:{
            m_rotateLocks_f(){


                this.locks_ao.forEach((lock_o, index) => {

                    if( lock_o.deg % 360 === 150 ){
                        this.$set(lock_o, "deg", lock_o.deg + 240);
                    }else {
                        this.$set(lock_o, "deg", lock_o.deg + 20);
                    }

                    if(lock_o.deg % 360 === 90){
                        this.selectedIndex_n = lock_o.id
                    }


                    this.m_setLine_f(lock_o)

                })

            },

            m_getLineName_fs(lineIndex_n){
                return "line_"+ lineIndex_n
            },
            m_getLockName_fs(lineIndex_n){
                return "lock_"+ lineIndex_n
            },

            m_setLine_f(item_o){

                let location = {
                    30  : {x : -20,     y: 405},
                    50  : {x : -65,     y: 340},
                    70  : {x : -105,    y: 275},
                    90  : {x : -175,    y: 190},
                    110 : {x : -105,    y: 110},
                    130 : {x : -65,     y: 45},
                    150 : {x : -20,     y: -15},
                }

                let deg = item_o.deg % 360

                item_o.refLine.style.transform  = "rotate(" + item_o.deg + "deg)"
                item_o.refImg.style.transform   = "translate(" + (location[deg].x + 90) + "px," + (location[deg].y + 50) + "px)"

            },

            m_clickLock_f(lock_o){

                let iteration_n = (7+3 - (((lock_o.deg - 30) %360) / 20) ) % 7

                date_setInterval(this.$options.name, 400, 400 * iteration_n, () => {
                    this.m_rotateLocks_f()
                })

            }

        },
        mounted(){

            this.locks_ao.forEach((lock_o, index) => {

                lock_o.refLine = this.$refs[this.m_getLineName_fs(index)][0]
                lock_o.refImg = this.$refs[this.m_getLockName_fs(index)][0]

                this.m_setLine_f(lock_o)

            })

        },
    }
</script>

<style scoped lang="scss">

    .lc_c_about_locks{
        position: relative;
        width: 400px;
        height: 500px;

        .lc_lock{
            position: absolute;
            right: 10px;
            top: 50% ;
            transform: translate(0, -50%);
        }

        .lc_lock1{
            position: absolute;
            right: 200px;
            top: -20px;

            transition-duration: 0.8s;
            transition-property: transform;
        }

        .lc_line {
            background: #000;
            height: 250px;
            right : 30px;
            position: absolute;
            top: 50% ;
            transform-origin: 0 0;
            width: 1px;
            border-radius: 8px;

            transition-duration: 0.8s;
            transition-property: transform;
        }

        .lc_selectedLock{
            background: gold;
            border: black 1px solid;
            padding: 4px;
            width: 48px;
            box-shadow: 0 4px 12px 0 rgba(0,0,0,0.2);
        }

    }





</style>